var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.head, on: { click: _vm.onClick } }, [
    _c("div", [_vm._t("default")], 2),
    _vm.isSorted
      ? _c("div", { staticClass: "material-icons", class: _vm.sortClass }, [
          _vm._v("sort"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }